import { Input, Component, OnInit, Inject, forwardRef, ChangeDetectorRef } from '@angular/core';
import { ContractorRegistrationDecisionActivity } from 'src/app/models/activities/contractor-registration-decision-activity';
import { SecurityService } from 'src/app/services';
import { FormActivityEditorComponent } from '../../form-activity-editor/form-activity-editor.component';
import { WorkflowContextService, WorkflowService } from 'src/app/services';
import { UntypedFormBuilder } from '@angular/forms';
import { DragulaService } from 'ng2-dragula';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'wm-contractor-registration-decision-activity-editor',
    templateUrl: './contractor-registration-decision-activity-editor.component.html',
    styleUrls: [
        './contractor-registration-decision-activity-editor.component.css'
    ],
    standalone: false
})
export class ContractorRegistrationDecisionActivityEditorComponent
  extends FormActivityEditorComponent
  implements OnInit {

  @Input() activity: ContractorRegistrationDecisionActivity;
  isGlobalAdmin: boolean;

  constructor(
    @Inject(forwardRef(() => WorkflowService)) workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    context: WorkflowContextService,
    fb: UntypedFormBuilder,
    dragulaSvc: DragulaService,
    ref: ChangeDetectorRef,
    toastr: ToastrService,
    private _securitySvc: SecurityService
  ) {
    super(workflowSvc, context, toastr, fb, dragulaSvc, ref);
  }

  ngOnInit() {
    this._securitySvc.isSystemAdministrator().subscribe(isAdmin => {
      this.isGlobalAdmin = isAdmin;
    });
  }
}
